var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutMission2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_2508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9584 27.7917H43.1251C43.1251 27.7917 45.0417 27.7917 45.0417 29.7084V43.1251C45.0417 43.1251 45.0417 45.0417 43.1251 45.0417H23.9584C23.9584 45.0417 22.0417 45.0417 22.0417 43.1251V29.7084C22.0417 29.7084 22.0417 27.7917 23.9584 27.7917Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0417 35.4584H45.0417",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5417 35.4584V38.3334",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2322 23.9584C35.588 23.9586 35.9368 24.0578 36.2394 24.245C36.5421 24.4322 36.7866 24.7 36.9457 25.0183L38.3333 27.7917H28.75L30.1377 25.0183C30.2967 24.7 30.5413 24.4322 30.8439 24.245C31.1465 24.0578 31.4953 23.9586 31.8512 23.9584H35.2322Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7492 18.6203L11.4999 25.3114L7.28711 18.5935",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4138 25.875L18.5916 22.8428C18.2097 21.252 17.3033 19.8362 16.0186 18.8234C14.7338 17.8105 13.1455 17.2598 11.5095 17.2598C9.87354 17.2598 8.28521 17.8105 7.00045 18.8234C5.7157 19.8362 4.80934 21.252 4.42742 22.8428L0.958252 35.4583H6.58367L8.60384 45.0416H14.3538L16.374 35.4583H18.2083",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0972 8.77262C18.1645 8.40765 18.2017 8.03777 18.2084 7.66671C18.2084 5.88755 17.5016 4.18126 16.2436 2.9232C14.9855 1.66514 13.2792 0.958374 11.5001 0.958374C9.72092 0.958374 8.01463 1.66514 6.75657 2.9232C5.49852 4.18126 4.79175 5.88755 4.79175 7.66671C4.79847 8.03777 4.83565 8.40765 4.90291 8.77262C6.15705 8.75479 7.39323 8.47181 8.53023 7.94229C9.66724 7.41276 10.6794 6.64867 11.5001 5.70021C12.3208 6.64867 13.3329 7.41276 14.4699 7.94229C15.6069 8.47181 16.8431 8.75479 18.0972 8.77262Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79175 7.66671C4.79175 8.54766 4.96526 9.41998 5.30239 10.2339C5.63951 11.0478 6.13365 11.7873 6.75657 12.4102C7.3795 13.0331 8.11902 13.5273 8.93291 13.8644C9.74681 14.2015 10.6191 14.375 11.5001 14.375C12.381 14.375 13.2534 14.2015 14.0673 13.8644C14.8811 13.5273 15.6207 13.0331 16.2436 12.4102C16.8665 11.7873 17.3606 11.0478 17.6978 10.2339C18.0349 9.41998 18.2084 8.54766 18.2084 7.66671C18.2084 6.78576 18.0349 5.91343 17.6978 5.09954C17.3606 4.28565 16.8665 3.54613 16.2436 2.9232C15.6207 2.30027 14.8811 1.80614 14.0673 1.46902C13.2534 1.13189 12.381 0.958374 11.5001 0.958374C10.6191 0.958374 9.74681 1.13189 8.93291 1.46902C8.11902 1.80614 7.3795 2.30027 6.75657 2.9232C6.13365 3.54613 5.63951 4.28565 5.30239 5.09954C4.96526 5.91343 4.79175 6.78576 4.79175 7.66671Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_2508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMission2);
export default __webpack_public_path__ + "static/media/aboutMission2.0dabcc070570f3d1d36cf58b4223e9fa.svg";
export { ForwardRef as ReactComponent };